import type { MetaplexPlatformName } from "../models/metaplex";

export enum MetaplexCreatorMint {
  Solpunks = "punknPuatYGcB6EM4Mt7q1qxz1PKhNiTmd1We1Srt9d",
  CryptoKickers = "kickNLAj7N8kfEtXLuhpYJLGwZjJahuz7nr9tjKgn8e",
  Solarians = "4nuNUbvQQ6hsYLFB9yAeDdhHRbbxa3vHQwhBbMkD66Sf",
  Sollamas = "LamapQPXuMYEuvsyZqK2UPqn1XCT2sW1soURj7ZJkZF",
  "Kaiju Cards" = "FGr9rJSQFP4ypFbJMhCotZh94ciMvcU3dApuDeXRi6vb",
}

export const METAPLEX_PLATFORMS: Record<MetaplexPlatformName, string> = {
  Solpunks: "punknPuatYGcB6EM4Mt7q1qxz1PKhNiTmd1We1Srt9d",
  CryptoKickers: "kickNLAj7N8kfEtXLuhpYJLGwZjJahuz7nr9tjKgn8e",
  Solarians: "4nuNUbvQQ6hsYLFB9yAeDdhHRbbxa3vHQwhBbMkD66Sf",
  Sollamas: "LamapQPXuMYEuvsyZqK2UPqn1XCT2sW1soURj7ZJkZF",
  "Kaiju Cards": "FGr9rJSQFP4ypFbJMhCotZh94ciMvcU3dApuDeXRi6vb",
};

// Name overrides for collections not indexed by SolanaFloor and missing collection nfts.
export const COLLECTIONS_BY_UPDATE_AUTH: Map<string, string> = new Map([
  ["gobYvGZVU1GWeyQDk1NMwV3nr6QYwN5RqJJ4bTMhJqu", "Goblin Labratory"],
  ["sntGbEduJMBeZgKpRjYFbYWpiaxn3EdNMuutcZD9Cw8", "Sentinels"],
  ["M1NTq6mJnYhyhRe1ZRum1v54AqHmvo4mYYGk7tcFcHn", "Star Atlas"],
]);
